import { FormattedMessage } from "react-intl";

import { Button } from "@/ui-components/commonComponents/Button/Button";

import style from "../style.module.css";

export function NextModalFooter({ handleOk, handleCancel }: { handleOk?: () => void; handleCancel?: () => void }) {
  return (
    <div className={style.actionButtons}>
      <Button key="ok" onClick={handleOk}>
        <FormattedMessage id="candidate.taking.confirmContinue" defaultMessage="continue" />
      </Button>
      <Button key="cancel" onClick={handleCancel}>
        <FormattedMessage id="candidate.taking.cancel" defaultMessage="cancel" />
      </Button>
    </div>
  );
}
